export var config = {
    api_url: "https://frc-backend.reklas.de/"
};
